import { PageName } from '@eastcoal/shared/enums/PageName'
import { PagePosition } from '@eastcoal/shared/enums/PagePosition'

import { BannerCarousel } from '../../../components/BannerCarousel'
import { FloorBlock } from '../../../components/FloorBlock'

import { NoticeBar } from './NoticeBar'

export const BannerFloor = () => {
  return (
    <FloorBlock>
      <BannerCarousel
        pageName={PageName.HOME}
        pagePosition={PagePosition.TOP}
      />
      <NoticeBar />
    </FloorBlock>
  )
}
